<template>
  <div>  
    <b-row >
  
     <div class="design-container-details__main">
        <div class="brand-card requestcard" >
        

            <div  class="col-md-12  mt-4">
        
                <b-form  @submit.prevent=" calculateTotalQuantity(index,quantity,factorysize,selected_size_data)" data-vv-scope="form-5">
    
                <div>
               <b-form-group label="Select Size Set"  :label-cols="3" >
           
                        <b-input-group :label-cols="8" style="width: 500px !important">

                          <ejs-multiselect id='sizemultiselect' placeholder="Select Size Set" v-model="selected_size_id" name="selected_size_id" :dataSource='caption_data' :fields='agentfields_size' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"  :class="{'input': true, 'is-invalid': errors.has('form-5.selected_size_id') }"  >
  
                    </ejs-multiselect>

                        </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('selected_size_id')" ></i>
                        </span>
                        <span class="icon has-text-warning"
                         v-show="errors.has('form-1.selected_size_id')">{{ errors.first('form-1.selected_size_id') }}</span>
                        </b-input-group>
                        
                      </b-form-group>
               
                  <b-form-group style="float:right;">
                    <b-button  variant="primary" class="" @click="searchFunction()">Request SizeSet</b-button>
                  </b-form-group> 
                </div>
                <br>

                <div class="table-responsive" style="display: none" id="temp_tbl">
                    <table class="table">
                    <thead class="requestedhead">
                    <tr>
                        <td scope="col" >Size Set</td>                
                        <td scope="col" >Unit</td>
                        <td scope="col"  v-if ="selected_sub_catid !== 170" >Age From</td>
                        <td scope="col"  v-if ="selected_sub_catid !== 170" >Age To</td>
                        <td scope="col"  v-if ="selected_sub_catid === 170" >UK</td>
                        <td scope="col"  v-if ="selected_sub_catid === 170" >US</td>
                        <td scope="col"  v-if ="selected_sub_catid === 170" >Foot Length CM</td>
                        <td scope="col"  v-if ="selected_sub_catid === 170" >Brand Size Euro</td>
                    </tr>
                    </thead>
                    <tbody class="requestedbody">
                    <tr v-for="(data, index) in selected_size_data">
                        <!-- {{data}} -->
                        <td ><label class="requestsize">Size &nbsp;</label >{{index+1}}</td>
                        <td >{{data.unit}}</td>
                        <td v-if ="selected_sub_catid !== 170">{{data.selectedfromage}}
                        </td>
                        <td v-if ="selected_sub_catid !== 170"> {{data.selectedtoage}}
                        </td>
                        <td v-if ="selected_sub_catid === 170"> {{data.uk}}
                        </td>
                        <td v-if ="selected_sub_catid === 170"> {{data.us}}
                        </td>
                        <td v-if ="selected_sub_catid === 170"> {{data.foot_length_cm}}
                        </td>
                        <td v-if ="selected_sub_catid === 170"> {{data.brand_size_euro}}
                        </td>
                    </tr>
                    </tbody>
                    </table>
                </div>

                <!-- <div class="table-responsive  table-striped">
                <table class="table col-md-12 " style="display: none" id="temp_tbl">
                    <thead class="requestedhead">
                    <tr>
                        <td scope="col" >Size Set</td>                
                        <td scope="col" >Unit</td>
                        <td scope="col" >Age From</td>
                        <td scope="col" >Age To</td>
                        <td scope="col" >Factory Size(In CM / In Inch)</td>
                        <td colspan="2" scope="col" >Quantity</td>
                    </tr>
                    </thead>
                    <tbody class="requestedbody">
                    <tr v-for="(data, index) in selected_size_data">
                       
                        <td ><label class="requestsize">Size &nbsp;</label >{{index+1}}</td>
                        <td >{{data.unit}}</td>

                        <td >{{data.selectedfromage}}
                        </td>
                        
                        <td > {{data.selectedtoage}}
                        </td>
                        
                        <td >
                        <b-form-input type="text" class="requestfactory" name="factorysize"   v-model="factorysize[index]" :key="index"  value="" required @change="addfactorysize(factorysize)"></b-form-input>
                        
                        </td>

                        <td >
                        <b-form-input class="requestquantity" type="text" name="quantity"   v-model="quantity[index]" :key="index"  required @change="calculatetotal(quantity,index); addquontity(quantity); checkpattern(quantity[index])"></b-form-input>
                        <b-input-group class="mb-3 requestquantity">
                            <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('quantity')" ></i>
                            </span>
                            <code v-show="errors.has('form-5.quantity')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.quantity') }}
                            </code>
                        </b-input-group>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </div> -->

                
          <b-form-group :label-cols="2" id="temp_tbl1" style="display: none;">
                  <b-button type="submit" variant="primary" class="px-4 pull-right" v-if="(style_details.assigned_to != null && user_type == 'Junior_Buyer') || (style_details.assigned_to == null && user_type == 'Buyer')  ||  user_type == 'Brand_Manager'" @click="savechartfunc()">Save SizeSet</b-button></b-form-group>
  
            <div class="col-md-12" ><label style="float: left;"><strong>Quotation Details</strong></label>


   
          <div class="col-md-12">
          <table class="table table-striped" >
            <thead class="requestedhead">
              <tr>
                <td scope="col" >Size Set</td>                
                <td scope="col" >Unit</td>
                <td scope="col" v-if ="selected_sub_catid !== 170" >Age From</td>
                <td scope="col" v-if ="selected_sub_catid !== 170" >Age To</td>
                <td scope="col" v-if ="selected_sub_catid !== 170">Factory Size(In CM / In Inch)</td>
                <td scope="col" v-if ="selected_sub_catid === 170">UK(In CM)</td>
                <td scope="col" v-if ="selected_sub_catid === 170">US(In CM)</td>
                <td scope="col" v-if ="selected_sub_catid === 170">Foot Length CM(In CM)</td>
                <td scope="col" v-if ="selected_sub_catid === 170">Brand Size Euro</td>
                <td scope="col" >Quantity</td>
                 <td scope="col" >MRP</td>
                <td scope="col" >Remove</td>
              </tr>
            </thead>
            <tbody class="requestedbody">
            <!-- {{selected_sizedata}} -->
              <tr v-for="(invoice_product, index) in sizeset">
                <td>
                  <b-form-input type="text" class="selected_month" name="selected_month"   v-model="unit[index]" :key="'unit'+index"  required disabled readonly></b-form-input> 
              </td>
              
                <td  ><label class="requestsize">Size &nbsp;</label >{{index+1}}</td> 
                
                <td v-if ="selected_sub_catid !== 170">
                  <b-form-input type="text" class="selectedfromage" name="selectedfromage"   v-model="selectedfromage[index]" :key="'selectedfromage'+index"  required disabled readonly></b-form-input>             
                </td>
                
                <td v-if ="selected_sub_catid !== 170"> 
                  
                  <b-form-input type="text" class="requestageto" name="requestageto"   v-model="selectedtoage[index]" :key="'selectedtoage'+index"  required disabled readonly></b-form-input>
                </td>

                <td v-if ="selected_sub_catid !== 170">
                  <b-form-input type="text" class="requestfactory" name="factorysize"   v-model="factorysize[index]" :key="'factorysize'+index"  required ></b-form-input>
                </td>

               

                <td v-if ="selected_sub_catid === 170">
                  <!-- <b-form-input class="requestquantity" type="text" name="quantity"   v-model="quantity[index]" :key="'quantity'+index"  required @change="calculatetotal(quantity,index); checkpattern(quantity[index])" ></b-form-input> -->
                  <b-form-input class="requestuk" type="text" name="uk"   v-model="uk[index]" :key="'uk'+index"  required disabled readonly ></b-form-input>
                </td>
                <td v-if ="selected_sub_catid === 170">
                  <!-- <b-form-input class="requestquantity" type="text" name="quantity"   v-model="quantity[index]" :key="'quantity'+index"  required @change="calculatetotal(quantity,index); checkpattern(quantity[index])" ></b-form-input> -->
                  <b-form-input class="requestuk" type="text" name="us"   v-model="us[index]" :key="'us'+index"  required disabled readonly ></b-form-input>
                </td>

                <td v-if ="selected_sub_catid === 170">
                  <!-- <b-form-input class="requestquantity" type="text" name="quantity"   v-model="quantity[index]" :key="'quantity'+index"  required @change="calculatetotal(quantity,index); checkpattern(quantity[index])" ></b-form-input> -->
                  <b-form-input class="requestfootlengthcm" type="text" name="foot_length_cm"   v-model="foot_length_cm[index]" :key="'foot_length_cm'+index"  required disabled readonly ></b-form-input>
                </td>

                <td v-if ="selected_sub_catid === 170">
                  <!-- <b-form-input class="requestquantity" type="text" name="quantity"   v-model="quantity[index]" :key="'quantity'+index"  required @change="calculatetotal(quantity,index); checkpattern(quantity[index])" ></b-form-input> -->
                  <b-form-input class="requestbrand_size_euro" type="text" name=""   v-model="brand_size_euro[index]" :key="'brand_size_euro'+index"  required disabled readonly ></b-form-input>
                </td>
                <td >
                  <!-- <b-form-input class="requestquantity" type="text" name="quantity"   v-model="quantity[index]" :key="'quantity'+index"  required @change="calculatetotal(quantity,index); checkpattern(quantity[index])" ></b-form-input> -->
                  <b-form-input class="requestquantity" type="text" name="quantity"   v-model="quantity[index]" :key="'quantity'+index"  :min="minRange" :max="maxRange" required @change="calculatetotal(quantity,index); " ></b-form-input>
                </td>
                <td >
                  <b-form-input type="text" class="requestfactory" name="mrp"   v-model="mrp[index]" :key="'mrp'+index"  @change="calculatetotal(quantity,index)"  required ></b-form-input>
                </td>

                <td ><i class="fa fa-times" @click="removeSize(index)"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
   
            <div class="col-md-12">
            <b-form  @submit.prevent="validateForm4('form-5',quantity);" data-vv-scope="form-5">
            <b-row>

              <b-col md="4">
                <!-- <label for="name">Select Vendors</label><br/>
                  
                    <div v-if="selectedvendors_length>0">
                      <button v-b-modal.modal-lg class="btn btn-link" @click="openvendorModal();" >{{selectedvendors_length}} <label>Vendors Selected</label></button>
                    </div>
                    <div v-if="selectedvendors_length==0">
                      <button v-b-modal.modal-lg class="btn btn-link" @click="openvendorModal()">Select Vendors</button>
                    </div> -->
              </b-col>

              <b-col md="4">
              </b-col>

              
              <b-col md="4">
                <label for="name">Total Quantity</label>
                <b-form-input type="text" id="totalsum" name="totalsum" v-model="totalsum" readonly disabled required autocomplete='off'>  
                </b-form-input>
                <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('totalsum')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.totalsum')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.totalsum') }}
                      </code>
                </b-input-group>
              </b-col>
                

              </b-row>

            <!--~~~~~~~~~~~~~~~~~~~~~~~~  -->

           <b-row >
                  
                <b-col md="4" v-if ="selected_sub_catid !== 170" >
                <b-form-group>
                      <label for="addmobilenumber">Material</label>
                      <!-- {{fabrictype_arr.title}} -->
                      <b-input-group class="mb-3">
                     <b-form-select v-model="material" id="material" name="material"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.material') }" >
                        <option :value="selected" >Select Option</option>
                        <option :value="fabrictype_list.title" v-for="fabrictype_list in fabrictype_arr">{{ fabrictype_list.title }}</option>
                    </b-form-select> 
                     <!-- <b-form-input list="fabrictype" v-model="fabrictype" name="fabrictype" placeholder="Please Select"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.fabrictype') }"></b-form-input> -->
                   <datalist id="fabrictype">
                    <!-- <option :value="selected"></option> -->
                    <!-- <select>
                      
                      <option  :value="fabrictype_list.title" v-for="fabrictype_list in fabrictype_arr" ></option>
                    </select>
                         -->
                  </datalist>
                </b-input-group>
                    <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('material')" ></i>
                        </span>
                        <code v-show="errors.has('form-5.material')" id="statustxt" class="help text-danger">{{ errors.first('form-5.material') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
              </b-col>
              <b-col md="4" v-if ="selected_sub_catid === 170" >
              <b-form-group>
                <label for="upper material">Upper Material</label>
             <b-input-group class="mb-3">
                <b-form-select placeholder="Select" v-model="upper_material"
                required :class="{'input': true, 'is-invalid': errors.has('form-1.materialinfoupperfabric') }">
                    <option value="">--Select--</option>
                    <option value="pu">PU</option>
                    <option value="pvc">PVC</option>
                    <option value="eva">EVA</option>
                    <option value="fabric">Fabric</option>
                    <option value="canvas">Canvas</option>
                    <option value="cotton">Cotton</option>
                    <option value="synthetic">Synthetic</option>
                    <option value="velvet">Velvet</option>
                    <option value="suede">Suede</option>
                    <option value="satin">Satin</option>
                    <option value="mesh">Mesh</option>
                    <option value="denim">Denim</option>
                    <option value="sequins Fabric">sequins Fabric</option>
                    <option value="glitter coated pu">Glitter coated PU</option>
                    <option value="knitted">Knitted</option>
                </b-form-select>
                <datalist id="materialinfoupperfabric">
                  <!-- <option :value="selected"></option>
                      <option  :value="materialinfoupperfabric_list.title" v-for="materialinfoupperfabric_list in materialinfoupperfabric_Upper_Fabric_arr"></option> -->
                 </datalist>
              </b-input-group>        
              <b-input-group class="mb-3">
                <span class="icon has-text-warning">
                  <i class="fa fa-warning" v-show="errors.has('material')" ></i>
                </span>
                <code v-show="errors.has('form-5.material')" id="statustxt" class="help text-danger">{{ errors.first('form-5.material') }}
                </code>
              </b-input-group>
            </b-form-group>
            </b-col>


            <b-col md="4" v-if ="selected_sub_catid === 170" >
              <b-form-group>
              <label for="Inner Lining">Inner Lining</label>
              <b-input-group class="mb-3">
              <b-form-select placeholder="Select" v-model="inner_lining"
              required :class="{'input': true, 'is-invalid': errors.has('form-1.materialinfoupperfabric') }">
                <option value="">--Select--</option>
                <option value="synthetics">Synthetics</option>
                <option value="wool">Wool</option>
                <option value="satin">Satin</option>
                <option value="suede">Suede</option>
                <option value="poplin">Poplin</option>
                <option value="cotton polyester">Cotton Polyester</option>
                <option value="polyester">Polyester</option>
                <option value="pvc">PVC</option>
                <option value="eva">EVA</option>
                <option value="unlined">Unlined</option>
                <option value="pu">PU</option>
              </b-form-select>
              <datalist id="materialinfoupperfabric">
                <!-- <option :value="selected"></option>
                    <option  :value="materialinfoupperfabric_list.title" v-for="materialinfoupperfabric_list in materialinfoupperfabric_Upper_Fabric_arr"></option> -->
               </datalist>
                  </b-input-group>
                  <b-input-group class="mb-3">
            
              <span class="icon has-text-warning">
                <i class="fa fa-warning" v-show="errors.has('material')" ></i>
              </span>
              <code v-show="errors.has('form-5.material')" id="statustxt" class="help text-danger">{{ errors.first('form-5.material') }}
              </code>
              </b-input-group>
            </b-form-group>
          </b-col>
          
          <b-col md="4" v-if ="selected_sub_catid === 170" >
            <b-form-group>
            <label for="sole">Sole</label>
            <b-input-group class="mb-3">
            <b-form-select placeholder="Select" v-model="sole"
            required
              class="input">
                <option value="">--Select--</option> 
                <option value="tpr">TPR</option>
                <option value="pu">PU</option>
                <option value="rubber">Rubber</option>
                <option value="eva">EVA</option>
                <option value="tpu">TPU</option>
                <option value="rubberized cork">Rubberized Cork</option>
                <option value="phylon">Phylon</option>
                <option value="thunit">Thunit</option>
                <option value="pu mix">PU Mix</option>
                <option value="rubber mix">Rubber Mix</option>
            </b-form-select>
            <datalist id="materialinfoupperfabric">
              <!-- <option :value="selected"></option>
                  <option  :value="materialinfoupperfabric_list.title" v-for="materialinfoupperfabric_list in materialinfoupperfabric_Upper_Fabric_arr"></option> -->
             </datalist>
                </b-input-group>

          
           <b-input-group class="mb-3">
            <span class="icon has-text-warning">
              <i class="fa fa-warning" v-show="errors.has('material')" ></i>
            </span>
            <code v-show="errors.has('form-5.material')" id="statustxt" class="help text-danger">{{ errors.first('form-5.material') }}
            </code>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="4" v-if ="selected_sub_catid === 170" >
          <b-form-group>
          <label for="Surface Ornamentation"> Surface Ornamentation</label>
          <b-input-group class="mb-3">
          <b-form-select placeholder="Select" v-model="surface_ornamentation"
          required :class="{'input': true, 'is-invalid': errors.has('form-1.materialinfoupperfabric') }">
          <option value="">--Select--</option>
          <option value="frill">Frill</option>
          <option value="sequins">Sequins</option>
          <option value="embellishment">Embellishment</option>
          <option value="ruffles">Ruffles</option>
          <option value="tassels">Tassels</option>
          <option value="reverse stripes">Reverse Stripes</option>
          <option value="tape">Tape</option>
          <option value="shoe charms">Shoe Charms</option>
          <option value="Printed">Printed</option>
          <option value="Applique">Applique</option>
          <option value="Embroidery">Embroidery</option>
          <option value="Texture Print">Texture Print</option>
          <option value="Quilted">Quilted</option>
          <option value="Trim">Trim</option>
          <option value="Buckle"> Buckle</option>
          <option value="Bow">Bow</option>
          <option value="NA">NA</option>
          </b-form-select>
         <datalist id="materialinfoupperfabric">
          <!-- <option :value="selected"></option>
              <option  :value="materialinfoupperfabric_list.title" v-for="materialinfoupperfabric_list in materialinfoupperfabric_Upper_Fabric_arr"></option> -->
         </datalist>
            </b-input-group>
        
         <b-input-group class="mb-3">
          <span class="icon has-text-warning">
            <i class="fa fa-warning" v-show="errors.has('material')" ></i>
          </span>
          <code v-show="errors.has('form-5.material')" id="statustxt" class="help text-danger">{{ errors.first('form-5.material') }}
          </code>
          </b-input-group>
        </b-form-group>
        </b-col>


        <b-col md="4" v-if ="selected_sub_catid === 170" >
          <b-form-group>
          <label for="Highlight">Highlight</label>
          <b-input-group class="mb-3">
          <b-form-select placeholder="Select" v-model="highlight"
          required
          class="input">
            <option value="">--Select--</option>
            <option value="color block">Color block</option>
            <option value="accent detailing">Accent detailing</option>
            <option value="light weight">Light weight</option>
            <option value="soft & flexible">Soft & flexible</option>
            <option value="color changing">Color changing</option>
            <option value="Vibrant print">Vibrant print</option>
            <option value="Floral Appliqu">Floral Applique</option>
            <option value="Shiny upper">Shiny upper</option>
            <option value="Bow Detail">Bow Detail</option>
            <option value="Saddle">Saddle</option>
            <option value="Glittering applique">Glittering applique</option>
            <option value="Glittering upper">Glittering upper</option>
            <option value="Water Proof">Water Proof</option>
            <option value="Washable">Washable</option>
            <option value="Braided detailing"> Braided detailing</option>
            <option value="Interlaced detailing">Interlaced detailing</option>
            <option value="Breathable">Breathable</option>
            <option value="Reflective detailing">Reflective detailing</option>
            <option value="Non Marking Sole"> Non Marking Sole</option>
            <option value="Ankle Support">Ankle Support</option>
            <option value="Dual Density Sole">Dual Density Sole</option>
            <option value="Studded Sole">Studded Sole</option>
            <option value="All terrain Shoes">All terrain Shoes</option>
            <option value="Arch Support">Arch Support</option>
            <option value="orthopedic footbed">Orthopedic Footbed</option>
          </b-form-select>
          <datalist id="materialinfoupperfabric">
            <!-- <option :value="selected"></option>
                <option  :value="materialinfoupperfabric_list.title" v-for="materialinfoupperfabric_list in materialinfoupperfabric_Upper_Fabric_arr"></option> -->
           </datalist>
              </b-input-group>

        
         <b-input-group class="mb-3">
          <span class="icon has-text-warning">
            <i class="fa fa-warning" v-show="errors.has('material')" ></i>
          </span>
          <code v-show="errors.has('form-5.material')" id="statustxt" class="help text-danger">{{ errors.first('form-5.material') }}
          </code>
          </b-input-group>
        </b-form-group>
        </b-col>

        <b-col md="4" v-if ="selected_sub_catid === 170" >
          <b-form-group>
          <label for="Fastening Type">Fastening Type</label>
          <b-input-group class="mb-3">
          <b-form-select placeholder="Select" v-model="Fastening_type"
            required
            class="input">
              <option value="">--Select--</option>
              <option value="slip-on">Slip-On</option>
              <option value="lace-up">Lace-Up</option>
              <option value="buckle">Buckle</option>
              <option value="zip">Zip</option>
              <option value="elastic">Elastic</option>
              <option value="velcro">Velcro</option>
              <option value="velcro+Elastic">Velcro + Elastic</option>
              <option value="snap button">Snap Button</option>
            </b-form-select>
            <datalist id="materialinfoupperfabric">
              <!-- <option :value="selected"></option>
                  <option  :value="materialinfoupperfabric_list.title" v-for="materialinfoupperfabric_list in materialinfoupperfabric_Upper_Fabric_arr"></option> -->
             </datalist>
                </b-input-group>
        
         <b-input-group class="mb-3">
          <span class="icon has-text-warning">
            <i class="fa fa-warning" v-show="errors.has('material')" ></i>
          </span>
          <code v-show="errors.has('form-5.material')" id="statustxt" class="help text-danger">{{ errors.first('form-5.material') }}
          </code>
          </b-input-group>
        </b-form-group>
        </b-col>

                <b-col md="4" v-if ="selected_sub_catid !== 170">
                  <b-form-group>
                      <label for="addmobilenumber">Top Fabric/Upper Fabric</label>
                      <b-input-group class="mb-3">
                        <b-form-select v-model="materialinfoupperfabric" id="materialinfoupperfabric" name="materialinfoupperfabric" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.materialinfoupperfabric') }" >
                        <option :value="selected"  >Select Option</option>
                        <option  :value="materialinfoupperfabric_list.title" v-for="materialinfoupperfabric_list in materialinfoupperfabric_Upper_Fabric_arr"  >{{ materialinfoupperfabric_list.title }}</option>
                    </b-form-select>
                    <!-- <b-form-input list="materialinfoupperfabric" v-model="materialinfoupperfabric" name="materialinfoupperfabric" placeholder="Please Select"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.materialinfoupperfabric') }"></b-form-input> -->
                   <datalist id="materialinfoupperfabric">
                    <!-- <option :value="selected"></option>
                        <option  :value="materialinfoupperfabric_list.title" v-for="materialinfoupperfabric_list in materialinfoupperfabric_Upper_Fabric_arr"></option> -->
                   </datalist>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('materialinfoupperfabric')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.materialinfoupperfabric')" id="materialinfoupperfabric" class="help text-danger">{{ errors.first('form-5.materialinfoupperfabric') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                </b-col>

                   <b-col sm="4" v-if ="selected_sub_catid !== 170">
                    <b-form-group>
                      <label for="addmobilenumber">Bottom Fabric/Sole Material</label>
                      <b-input-group class="mb-3">
                        <b-form-select v-model="solematerial" id="solematerial" name="solematerial" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.solematerial') }" >
                        <option :value="selected"  >Select Option</option>
                        <option  :value="sole_material_list.title" v-for="sole_material_list in solematerial_Sole_Material_arr"  >{{ sole_material_list.title }}</option>
                    </b-form-select>
                    <!-- <b-form-input list="solematerial" v-model="solematerial"  name="solematerial" placeholder="Please Select"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.solematerial') }"></b-form-input> -->
                   <datalist id="solematerial">
                    <!-- <option :value="selected"></option>
                        <option  :value="sole_material_list.title" v-for="sole_material_list in solematerial_Sole_Material_arr"></option> -->
                   </datalist>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('solematerial')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.solematerial')" id="solematerial" class="help text-danger">{{ errors.first('form-5.solematerial') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
              </b-row>
              <b-row>

              <b-col md="4" v-if ="selected_sub_catid !== 170">
                <b-form-group >
                <label for="fabriccomposition">Fabric Type</label>
                  <b-input-group class="mb-3">
                    <b-form-select v-model="fabrictype" id="fabrictype" name="fabrictype"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.fabrictype') }">
                          <option :value="selected" >Select Option</option>
                          <option value="knit">Knit</option>
                          <option value="woven">Woven</option>
                        </b-form-select> 
                        <datalist id="materialinfoupperfabric">
                          <!-- <option :value="selected"></option>
                              <option  :value="materialinfoupperfabric_list.title" v-for="materialinfoupperfabric_list in materialinfoupperfabric_Upper_Fabric_arr"></option> -->
                         </datalist>
                      </b-input-group>
                  
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('fabrictype')" ></i>
                          </span>
                          <code v-show="errors.has('form-5.fabrictype')" id="statustxt" class="help text-danger">{{ errors.first('form-5.fabrictype') }}
                          </code>
                        </b-input-group>
                    </b-form-group>

              </b-col>

                <b-col sm="4" v-if ="selected_sub_catid !== 170">
                  <b-form-group>
                  
                    <label for="fabriccomposition">Fabric Composition</label>
                    <b-input-group class="mb-3">
                        
                        <b-form-input class="input" type="text" id="fabriccomposition" v-model="fabriccomposition" name="fabriccomposition"  v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.fabriccomposition') }" placeholder="Enter Fabric Composition" >
                        </b-form-input>  
                    </b-input-group>
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i class="fa fa-warning" v-show="errors.has('fabriccomposition')" ></i>
                    </span>
                    <code v-show="errors.has('form-5.fabriccomposition')" id="fabriccomposition" class="help text-danger">{{ errors.first('form-5.fabriccomposition') }}
                    </code>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                  <b-col sm="4" v-if ="selected_sub_catid !== 170">
                    <b-form-group>
                      <label for="addmobilenumber">Sleeve length</label>
                      <b-input-group class="mb-3">
                        <b-form-select v-model="sleevelength" id="sleevelength" name="sleevelength" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.sleevelength') }" >
                        <option :value="selected"  >Select Option</option>
                        <option  :value="sleeveLength_arr_list.title" v-for="sleeveLength_arr_list in sleeveLength_arr"  >{{ sleeveLength_arr_list.title }}</option>
                    </b-form-select>
                    <!-- <b-form-input list="sleevelength" v-model="sleevelength"  name="sleevelength" placeholder="Please Select"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.sleevelength') }"></b-form-input> -->
                   <datalist id="sleevelength">
                    <!-- <option :value="selected"></option>
                        <option  :value="sole_material_list.title" v-for="sole_material_list in sleevelength_Sole_Material_arr"></option> -->
                   </datalist>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('sleevelength')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.sleevelength')" id="sleevelength" class="help text-danger">{{ errors.first('form-5.sleevelength') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col>

              
              </b-row>


            <!-- ~~~~~~~~~~~~~~~~~~~~~~~ -->
            <b-row >
                  
                <b-col md="4">
                <label for="name">Target Price / Piece </label>
                <b-form-input type="number" step="any" v-validate="'between:0,10000000000'" id="target_price" name="target_price" v-model="target_price" placeholder="Enter Target Price "  required >   
                </b-form-input>
                <span class="icon has-text-warning text-danger">
                  <i class="fa fa-warning text-danger  mt-2" v-show="errors.has('form-5.target_price')"> Only positive numbers are allowed</i>
                </span>
                <!-- <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('target_price')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.target_price')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.target_price') }}
                      </code>
                  </b-input-group> -->
                
              </b-col>
                <b-col md="4">
                  <label for="name">Quote Submission Last Date</label><br>
                      
                      <datepicker :bootstrap-styling="true" slot="beforeCalendarHeader" class="calender-header" v-model="submissionDate" id="enddate" :format="DatePickerFormat" :disabledDates="disabledDates" required>
                  Choose a Date
                 
                  </datepicker>
                  <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('submissionDate')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.submissionDate')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.submissionDate') }}
                      </code>
                  </b-input-group>
                  
                </b-col>  

                <b-col md="4">
                  <label for="name">Expected Delivery Date</label>
                  <!-- <b-col md="12">     -->
                      <datepicker :bootstrap-styling="true"
                   slot="beforeCalendarHeader" class="calender-header" v-model="requestedDate" id="startdate" :format="DatePickerFormat" :disabledDates="disabledDates" required>
                  Choose a Date
                  
                  </datepicker>
                  <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('requestedDate')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.requestedDate')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.requestedDate') }}
                      </code>
                  </b-input-group>
                  <!-- </b-col>   -->
                </b-col>
                <b-col>
                  <div>
                    <label><b>Remarks</b></label>
                    <b-form-textarea class="m-2 col-8" rows="3" maxlength="100" type="textarea" name="remarks" v-model="quote_remarks" :key="index" required ></b-form-textarea>
                    <!-- <span>100 character limit</span> -->
                  </div>
                </b-col>
              
              </b-row>
            <div slot="footer" style="margin-top:20px" id="upload_btn">           
              <b-button  v-if="(style_details.assigned_to != null && user_type == 'Junior_Buyer') || (style_details.assigned_to == null && user_type == 'Buyer')   || (style_details.assigned_to == null && user_type == 'Brand_Manager')" type="submit" variant="primary" class="px-4 pull-right" @click="sendDataToParent">Request Quote </b-button>
            </div>
            <br><br>
         </b-form>
       </div>
       </div>
       </b-form>
      
    <!-- </b-row> -->
    </div>


                   <!-- Code For Design Details Model -->
      <b-modal id="modal-lg" size="lg" title="Vendors Details" v-model="showvendordetails" @ok="showvendordetails = false" >
      <b-row>
    
      <b-col sm="12" class='col-md-12'>
        
        <b-form name="addSegmentForm" >

                 <div  class='col-md-12' id="vendor_list_scroll">    

              <b-row class="col-md-12 ">
                 <b-col md="2"><label style="font-size: 15px; padding-top: 4px;"><b>Search:</b></label></b-col>
                
                  <b-col md="8">
                    <!-- <input type="text" id="myInput" v-on:keyup="myFunction()" placeholder="Search for vendors name..." contenteditable="true" title="Type in a name" class="requestvendor" style="background-color: #ffffff;opacity: .4;"> -->
                <input type="text" id="myInput" v-on:keyup="myFunction()" placeholder="Search for vendors name..." contenteditable="true" title="Type in a name" class="requestvendor">
              </b-col>
               <b-col md="2"><i class="fa fa-search requesticon" aria-hidden="true" ></i></b-col>
              </b-row><br>

                  <b-form-group>
                    <div id='myapp'>
                      <div v-if="vendor_msg =='Successful'"><input type='checkbox' @click='checkAll()' v-model='isCheckAll'> Check All </div>
                      <table class="table col-md-12 table-bordered" id="myTable">
                        <thead class="requestvendorhead">
                          <tr>
                            <td scope="col">Name</td>
                            <td scope="col">Vendor Code</td>
                            <td scope="col">City</td>
                            <td scope="col">Address</td>
                          </tr>
                        </thead>
                        <tbody class="requestvendorbody" v-if="vendor_msg=='Successful'">
                      <tr v-for='opt in agentmaster'>
                        <td>
                         <input type='checkbox' v-bind:value='opt.vendor_id' v-model='selectedvendors' @change='updateCheckall()' required="selectedvendors">&nbsp;{{ opt.vendor_name }}
                        </td>
                        <td>{{opt.vendor_code}}</td>
                        <td>{{opt.vendor_city}}</td>
                        <td>{{opt.vendor_address}}</td>
                      </tr>
                      </tbody>
                      <tbody v-if="vendor_msg=='Unsuccessful'"> 
                        <tr>
                          <td colspan="3" style="text-align: center;">No Records Found</td>
                        </tr>
                      </tbody>

                      </table>
                   

                    </div>

                  </b-form-group>

                </div>          

              <!-- </div> -->
            <div slot="footer"  style="margin-top:20px;text-align:right">
            <!-- <router-link :to="'/design_quotes/' + route_id"> -->
              <button type="button" class="btn btn-success" @click="addVendor();">Submit</button>&nbsp;&nbsp;
             <button type="button" class="btn btn-danger" @click="cancelVendor()">Cancel</button>

            </div>
         </b-form>
      </b-col>

    </b-row>
    </b-modal>
             <!-- Code For Design Details Ends -->

    
               <!-- </div> -->
            </div>
        </div>

 </b-row>    



   </div>


 
</template>

<script>

   import CONSTANTS from '@/utils/constants'
   import auth from '@/utils/auth'
   import Vue from 'vue'
   import Router from 'vue-router'
   import Datepicker from 'vuejs-datepicker'
   import VeeValidate from 'vee-validate'
   Vue.use(VeeValidate)

import { MultiSelectPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns';
MultiSelect.Inject(CheckBoxSelection);
Vue.use(MultiSelectPlugin);

   import navbarMenu from './_navbarMenu.vue'
   
   const axios = require('axios')
   export default {
    props:["showEditSizedetailsModal"],
     name: 'Tabs',
     components: {

        navbarMenu,
         Datepicker
      },  

     data () {
       return {

        style_details:[],
        showSelectAll : true,
        allowCustomValue : true,
        delivery_date:'',
        submission_date: '',
        fabrictype_data:'',
        target_price:"",
        total_quantity: 0,
        submissionDate: '',
        requestedDate: '',
        DatePickerFormat: 'dd/MM/yyyy',
        disabledDates: {
        to: new Date(Date.now() - 8640000)
        },
        route_id: '',
        selectedfromage:[],
        selectedtoage: [],
        agentfields_size: { text: 'sizeset_caption', value: 'sizeset_id' },
        selectedVendor:[],
        vendor_options: [],
        age_from: [],
          //age_to: [],
        age_to: [],
          unit_arr: [
          { value: '0', text: 'Month' },
          { value: '1', text: 'Year' }
          ],
          selectedunit: '',
        sizeset: [],
      
        showvendordetails: false,
        customer:{},
        isCheckAll: false,
        selectedvendors: [],
        selectedlang: "",
        quantity: [],
        factorysize: [],
        selectedage: 0,
        index:1,
         quote_remarks: "",

         fabriccomposition: '',
        // invoice_products:[],
        invoice_products: [{
          unit: [],
          selectedfromage: [],
          selectedtoage: [],
          quantity: [],
          // factorysize: [],
        }],

        selected_sub_catid: 0,
        totalsum: 0,
        fileupload_status: false,
        selected_brandid: 0,
        selected_sub_catid: 0,
        agentmaster:[],
        vendor_msg:'',
        age_torange: [],
        selectedvendors_length: 0,
       
        fullPage: true,
        search_text:'',
        user_type: '',
        selected_month: [],
        selected_sizset: 0,
        selected_age: 0,
        selected: '',
        total_qty_arr: [],
        
        count: 0,
        quotationlist: [],
        agefrmto_default: [
          { value: '', text: '-- Select --' }
          
          ],

       month_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' },
              { value: '13', text: '13' },
              { value: '14', text: '14' },
              { value: '15', text: '15' },
              { value: '16', text: '16' },
              { value: '17', text: '17' },
              { value: '18', text: '18' },
              { value: '19', text: '19' },
              { value: '20', text: '20' },
              { value: '21', text: '21' },
              { value: '22', text: '22' },
              { value: '23', text: '23' },
              { value: '24', text: '24' }
            ],      
          year_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' },
              { value: '13', text: '13' },
              { value: '14', text: '14' },
              { value: '15', text: '15' },
              { value: '16', text: '16' }            
              ],
          to_month_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' },
              { value: '13', text: '13' },
              { value: '14', text: '14' },
              { value: '15', text: '15' },
              { value: '16', text: '16' },
              { value: '17', text: '17' },
              { value: '18', text: '18' },
              { value: '19', text: '19' },
              { value: '20', text: '20' },
              { value: '21', text: '21' },
              { value: '22', text: '22' },
              { value: '23', text: '23' },
              { value: '24', text: '24' }
            ],      
          to_year_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' },
              { value: '13', text: '13' },
              { value: '14', text: '14' },
              { value: '15', text: '15' },
              { value: '16', text: '16' }            
              ], 
          file_tab_status: false,   
          temp_sizeset:0,
          qtycount: 0,
          counter: 0,
          temp_count: 0,
          caption_data: [],
          selected_size_id: [],
          selected_size_data: [],
          sizeset_caption: [],
          agefrom: [],
          ageto: [],
          showSelectAll : true,
          main_arr: [],
          factory_arr: [],
          quontity_arr: [],
          selected_arr: [],
          tbl_invoice_products:[{
            tbl_unit: [],
            tbl_selectedfromage: [],
            tbl_selectedtoage: [],
            tbl_factorysize: [],
            tbl_quantity: [],
          }
            ],
            tbl_selected_month:[],
          tbl_selectedfromage:[],
          tbl_selectedtoage:[],
          solematerial_Sole_Material_arr: [],
          sleeveLength_arr:[],
          materialinfoupperfabric_Upper_Fabric_arr:[],
          fabrictype_arr:[],
          selected_sizedata: [],
          size_flag: 0,
          fabrictype:'',
          materialinfoupperfabric: '',
         solematerial: '',
          sleevelength:'',
          
          quantity_arr:[],
          material:'',
          mrp:[],
          total_mrp : 0,
          upper_material:'',
          inner_lining:'',
          sole:'',
          surface_ornamentation:'',
          highlight:'',
          Fastening_type:'',
          uk:[],
          us:[],
          brand_size_euro:[],
          foot_length_cm:[],
          final_grade:'',
          minRange:'',
          maxRange:'',
       }
       
     },
     created: function() { 
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      // this.getsizecaption();
      // this.getdesigndetail1(); 
      this.getdesigndetail1();
      this.getqutationdetails();
      this.getselectedvendorsquote();
      
      // this.poformdata();

      //  this.fabrictype = '';
      //  this.materialinfoupperfabric = '';
      
      this.route_id=this.$route.params.id; 

      this.user_type = userInfo[0].user_type;
      if(userData) 
      {
      //alert("IN");
        this.quote_tab=true;
        this.message_tab=true;
      }

      

     },
     
       methods: { 
               getdesigndetail1: function(){
   
           this.isBusy = true;
       
           const Obj = {
                style_id: this.$route.params.id       
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
            this.style_details  = this.result.returnvalue[0];
            // this.selected_sizedata=this.style_details.size_details;
            this.selected_brandid = this.style_details.brand_id;
            this.selected_sub_catid = this.style_details.sub_catid;
            this.sizeset = this.style_details.no_of_sizeset;
            this.temp_sizeset=this.style_details.no_of_sizeset;
            this.materialinfoupperfabric = this.style_details.materialinfoupperfabric;
            this.material = this.style_details.material;
            this.solematerial = this.style_details.solematerial;
            this.sleevelength =  this.style_details.sleevelength;
            this.fabrictype = this.style_details.fabrictype;
            this.fabriccomposition = this.style_details.fabriccomposition
            this.upper_material = this.style_details.upper_material;
            this.inner_lining = this.style_details.inner_lining;
            this.sole =   this.style_details.sole;
            this.surface_ornamentation = this.style_details.surface_ornamentation;
            this.highlight = this.style_details.highlight;
            this.Fastening_type =   this.style_details.fastening_type;
            this.final_grade = this.style_details.final_grade;
            this.getMinMaxRangeFromFinalGrade(this.final_grade)
            // this.sleevelength =  this.style_details.sleevelength
            
            //Added Code
            if(this.temp_sizeset>0){

              if(this.style_details.size_details[0].unit && this.style_details.size_details[0].unit.length!=0){
                  for(let i=0;i<this.style_details.size_details[0].unit.length;i++){
                  var temp_selected_unit= this.style_details.size_details[0].unit;
              }
                }
              if(this.style_details.size_details[0].selectedfromage && this.style_details.size_details[0].selectedfromage.length!=0){
                for(let i=0;i<this.style_details.size_details[0].selectedfromage.length;i++){
                var temp_selected_fromage= this.style_details.size_details[0].selectedfromage;
              }
              }

              if(this.style_details.size_details[0].selectedtoage && this.style_details.size_details[0].selectedtoage.length!=0){
                for(let i=0;i<this.style_details.size_details[0].selectedtoage.length;i++){
                var temp_selected_toage=this.style_details.size_details[0].selectedtoage;
              }
              }

            var temp_qty = []
            if(this.style_details.size_details[0].quantity && this.style_details.size_details[0].quantity.length!=0){
              for(let i=0;i<this.style_details.size_details[0].unit.length;i++){
                if(this.style_details.size_details[0].quantity[0][i]!=undefined){
                  temp_qty.push(this.style_details.size_details[0].quantity[0][i]);
                }

              }

            }
            var temp_factorysize = []
            if(this.style_details.size_details[0].factorysize && this.style_details.size_details[0].factorysize.length!=0){
                for(let i=0;i<this.style_details.size_details[0].unit.length;i++){
                // var temp_factorysize= this.style_details.size_details[0].factorysize[0];
                if(this.style_details.size_details[0].factorysize[0][i]!=undefined){
                  temp_factorysize.push(this.style_details.size_details[0].factorysize[0][i])
                }
              }
            }

            var temp_mrp = []
            if(this.style_details.size_details[0].mrp && this.style_details.size_details[0].mrp.length!=0){
                for(let i=0;i<this.style_details.size_details[0].unit.length;i++){

                if(this.style_details.size_details[0].mrp[0][i]!=undefined){
                  temp_mrp.push(this.style_details.size_details[0].mrp[0][i])
                }
;              }
            }
          
            if(this.style_details.size_details[0].uk && this.style_details.size_details[0].uk.length!=0){
                for(let i=0;i<this.style_details.size_details[0].uk.length;i++){
                var temp_uk = this.style_details.size_details[0].uk
              }
            }
            if(this.style_details.size_details[0].us && this.style_details.size_details[0].us.length!=0){
                for(let i=0;i<this.style_details.size_details[0].us.length;i++){
                var temp_us = this.style_details.size_details[0].us
              }
            }
            if(this.style_details.size_details[0]['brand_size_euro'] && this.style_details.size_details[0]['brand_size_euro'].length!=0){
                for(let i=0;i<this.style_details.size_details[0]['brand_size_euro'].length;i++){
                  var temp_brand_size_euro =  this.style_details.size_details[0].brand_size_euro
              }
            }
             temp_foot_length_cm = [];
            if(this.style_details.size_details[0]['foot_length_cm'] && this.style_details.size_details[0]['foot_length_cm'].length!=0){
                for(let i=0;i<this.style_details.size_details[0]['foot_length_cm'].length;i++){
                var temp_foot_length_cm = this.style_details.size_details[0].foot_length_cm;
              }
            }

            this.unit=temp_selected_unit;
            this.selectedfromage= temp_selected_fromage;
            this.selectedtoage= temp_selected_toage;
            this.quantity= temp_qty;
            this.factorysize= temp_factorysize; 
            this.mrp = temp_mrp;
            this.uk = temp_uk;
            this.us = temp_us;
            this.brand_size_euro = temp_brand_size_euro;
            this.foot_length_cm = temp_foot_length_cm;
            let tempObj = {}
            tempObj.unit = temp_selected_unit
            tempObj.selectedfromage = temp_selected_fromage;
            tempObj.selectedtoage = temp_selected_toage;
            tempObj.quantity = [temp_qty]
            tempObj.factorysize = [temp_factorysize]
            tempObj.mrp = [temp_mrp],
            tempObj.uk = temp_uk,
            tempObj.us = temp_us,
            tempObj.brand_size_euro = temp_brand_size_euro,
            tempObj.foot_length_cm = temp_foot_length_cm
            let tempArr = []
            tempArr.push(tempObj)
            this.selected_sizedata = tempArr
                  // for(var i_sr=0;i_sr<=this.quantity.length-1;i_sr++)
                  // {

               

                  //   if(this.quantity[i_sr] == null || this.quantity[i_sr] =="" || this.quantity[i_sr]=="undefined") 
                  //   {
                     
                  //   }
                  //   else
                  //   {
                      
                  //     this.totalsum = parseInt(this.totalsum) + parseInt(this.quantity[i_sr]);       
                  //   }
                  // }
            }
            //Added Code Ends
            this.selected_sub_catid = this.style_details.sub_catid;
            this.getsizecaption(this.selected_brandid,this.selected_sub_catid);
            this.poformdata(this.selected_sub_catid);
            this.getfabrictype()

            this.displayvendorlist(this.selected_brandid,this.selected_sub_catid);
            }

            // console.log("this.invoice_products",this.invoice_products)
            // console.log(this.selected_sizedata[0].unit.length)
            // console.log("Updated this.selected_sizedata", this.selected_sizedata[0].quantity[0].length);

            // const array = temp_qty
            // const lengthToSum = temp_selected_unit; // Change this to the desired length

            // let sum = 0;

            // // Iterate over the first 'lengthToSum' elements and accumulate the sum
            // for (let i = 0; i < lengthToSum && i < array.length; i++) {
            //     sum += parseInt(array[i]);
            // }

            // console.log(sum,"this.selected_sizedata[0].unit.length");

              
        })
           
   
   
       },
        addfactorysize:function(val){
          // alert("innnfatc")
          this.factory_arr.push(val);
          console.log("this.factory_arr",this.factory_arr);
        },
        addquontity:function(val){
          // alert("InQuo")
          this.quantity_arr.push(val)
          console.log("this.quantity_arr",this.quantity_arr);
        },
        savesizedata: function(){
          console.log("")
        },

         searchFunction: function () {
            // this.factorysize =[]
            // this.quantity = []
          document.getElementById("overlay").style.display = "block";
            const Obj={
             sizeset_id:this.selected_size_id
        }
        axios.post(`${CONSTANTS.API_URL}/getValuesForAgeFromAgeTo`,Obj)
         .then(response => {
          document.getElementById("overlay").style.display = "none";
          if(response.data.returnmsg=='Successful')
          {
            this.selected_size_data = response.data.returnvalue;
            document.getElementById('temp_tbl').style.display="block";
            document.getElementById('temp_tbl1').style.display="block";
            document.getElementById('temp_tbl').style.display="block";
            // console.log("Paass")
            // alert("end")
          }
          else{
            this.selected_size_data =[];
          }
          
          
        }).catch((err) =>{
            document.getElementById("overlay").style.display = "none";
            return new Error(err.message);
          })
      },


      getsizecaption:function(brand_id,sub_id){
        // alert("kk")
        const Obj={
              brand_id: this.selected_brandid,
              subcat_id: this.selected_sub_catid
              // brand_id:621,
              // subcat_id:169
        }
      axios.post(`${CONSTANTS.API_URL}/getCaptionForAgeFromAgeTo`,Obj)
       .then(response => {
        if(response.data.returnmsg=='Successful')
        {
          this.caption_data = response.data.returnvalue;
        }
        else{
          this.caption_data =[];
        }
      }).catch((err) =>{
          return new Error(err.message);
        })

    },

        
        checkpattern: function(value){
          // alert(value)
          const regex = /^[1-9]\d*(\.\d+)?$/;
          const str = regex.test( value ) ? 'Match!' : 'No Match';
          if(str==='No Match'){
            this.$fire({
                text:"Please Enter Number Values Only",
                type: "warning",
                timer: 300000
                      })
            document.getElementById('upload_btn').style.display="none";
          }
          else{
            document.getElementById('upload_btn').style.display="block";
          }
        },

        //Method to check age value
        checkagevalue(from_age, to_age, index){
          // if(to_age<from_age){
          //   alert(index +"th Position Age To' Value Should Be Greater Than Or Equal To 'Age From' Value");
          // }
        },
        //Method ends

        //Method to Calculate Total Quantity- By Prasad
        calculatetotal: function(qty,index){
        //   alert(this.minRange);
        //  alert(this.maxRange);

        let value = qty[index];
          const regex = /^[1-9]\d*(\.\d+)?$/;
          const isNumber = regex.test(value);

          if (!isNumber) {
              this.$fire({
                  text: "Please Enter Number Values Only",
                  type: "warning",
                  timer: 3000 // Corrected to 3000 milliseconds (3 seconds)
              });
              document.getElementById('upload_btn').style.display = "none";
              return; // Exit the function if value is not a valid number
          }

          value = parseFloat(value); // Convert the value to a number

          if (value < this.minRange || value > this.maxRange) {
            
            alert(`Quantity must be between ${this.minRange} and ${this.maxRange}`);
            this.$set(qty, index, '');// Clear the input or set to the closest valid value
            document.getElementById('upload_btn').style.display = "none";
            return; // Exit the function if the value is out of range
        } 
          else{
            // alert(this.final_grade)
            document.getElementById('upload_btn').style.display="block";
            // calculatetotal original
            const array = this.quantity;
            
            const lengthToSum = this.unit.length; // Change this to the desired length
            let sum = 0;
            let tempTotalMrp =0
            // Iterate over the first 'lengthToSum' elements and accumulate the sum
            for (let i = 0; i <= lengthToSum; i++) {
              // console.log('array[i] '+i+'----->',array[i])
              if(array[i]){
                // console.log("parseInt(array[i])", parseInt(array[i]))
                // console.log("thismrp", this.mrp[i])
                sum = sum + parseInt(array[i]);
              }
              if(this.mrp[i])
                {
                    tempTotalMrp = parseInt(array[i]) * parseInt(this.mrp[i])
                }

            }
            this.total_mrp = tempTotalMrp
            this.totalsum = sum
            // console.log('totalSum------------->',sum);
          }
          
        },

        calculatetotalWrong: function(qty,index){
        
        const array = this.selected_sizedata[0].quantity[0];
                    const lengthToSum = this.selected_sizedata[0].unit.length; // Change this to the desired length

                    let sum = 0;

                    // Iterate over the first 'lengthToSum' elements and accumulate the sum
                    for (let i = 0; i < lengthToSum && i < array.length; i++) {
                        sum += parseInt(array[i]);
                    }

            this.totalsum = sum

          },


 
        calculateTotalQuantity: function(index,qty,factorysize,data){
          document.getElementById("overlay").style.display = "block";

          let currentSizeDataObj = {...this.selected_sizedata[0]}
          
          let newSizeDataObj = {...this.selected_sizedata[0]}
          data.map((item,index)=>{
            let idx = currentSizeDataObj.unit.indexOf(item.unit)
            if(idx ==-1){
              if(this.selected_sub_catid !== 170){
              newSizeDataObj.unit.push(item.unit)
              newSizeDataObj.selectedtoage.push(item.selectedtoage)
              newSizeDataObj.selectedfromage.push(item.selectedfromage)
              newSizeDataObj.quantity[0].push(0)
              newSizeDataObj.factorysize[0].push(0)
              newSizeDataObj.mrp[0].push(0)
              }else{
              newSizeDataObj.unit.push(item.unit)
              newSizeDataObj.uk.push(item.uk)
              newSizeDataObj.us.push(item.us)
              newSizeDataObj.foot_length_cm.push(item['foot_length_cm']);
              newSizeDataObj.brand_size_euro.push(item['brand_size_euro']); 
              newSizeDataObj.quantity[0].push(0)
              newSizeDataObj.mrp[0].push(0)
              }
            }else{
              if(this.selected_sub_catid !== 170){
              newSizeDataObj.unit[idx] = item.unit
              newSizeDataObj.selectedtoage.push(item.selectedtoage)
              newSizeDataObj.selectedfromage.push(item.selectedfromage)
              newSizeDataObj.quantity[0][idx] = newSizeDataObj.quantity[0][idx]
              newSizeDataObj.mrp[0][idx] = newSizeDataObj.mrp[0][idx]
              }else{
                newSizeDataObj.unit[idx] = item.unit
                newSizeDataObj.uk[idx] = item.uk
                newSizeDataObj.us[idx] = item.us
                newSizeDataObj.foot_length_cm[idx] = item.foot_length_cm
                newSizeDataObj.brand_size_euro[idx] = item.brand_size_euro
                newSizeDataObj.quantity[0][idx] = newSizeDataObj.quantity[0][idx]
                newSizeDataObj.mrp[0][idx] = newSizeDataObj.mrp[0][idx]
              }
            }
          })
          
          let tempArr = []
          tempArr.push(newSizeDataObj)
          this.selected_sizedata[0] = newSizeDataObj

          let sum = 0
          for(let i=0;i<=newSizeDataObj.unit.length;i++){
            if(newSizeDataObj.quantity[0][i]){
              sum+= parseInt(newSizeDataObj.quantity[0][i])
            }
          }
          this.totalsum = sum
          const Obj={
            style_id: this.$route.params.id,
            size_details: JSON.stringify(tempArr)
          }
          axios.post(`${CONSTANTS.API_URL}/updateSizeSetData`,Obj)
          .then(response => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data
            if (this.result.returnmsg === 'Successful') {
              this.selected_arr  = this.result.returnvalue;
              this.getdesigndetail();
              this.size_flag=1;
            }else {
              this.selected_arr =[];
            }
          })
          .catch(e => {
            document.getElementById("overlay").style.display = "none";
            this.fire({text:"Error in Updating Size Details!",type:'error'})
          })
          
        },

calculateTotalQuantityWrong: function(index,qty,factorysize,data) 
{
document.getElementById("overlay").style.display = "block";
  
  // console.log("KKKKKKKKKKKKKKKKKKKKqty",qty);
  // console.log("LLLLLLLLLLLLLLLLLLLLLLindex",index);
  // console.log("IIIIIIIIIIIIIIIIIIIIIIIIIIIIIIfactorysize",factorysize);
  //console.log("HHHHHHHHHHHHHHHHunit",data)
  // return false;
  // var selectedfromage=[];
  // var selectedtoage=[];
  // var unit= [];
  // selectedfromage.push(data[0].agefrom);
  // selectedtoage.push(data[0].ageto)   
  // unit.push(data[0].sizeset_caption)

  // return false;
  // alert(index);
  // alert("from_age" +from_age[index]);
  // alert("to_age" +to_age[index]);
  // if(from_age[index]>to_age[index]){
  //   alert(index +"th Position 'Age To' Value Should Be Greater Than Or Equal To 'Age From' Value");
  // }
  
  // else 
  //   if(this.quantity.length >0)
  // {
  //    this.totalsum =0; 

  //  ;

  //   for(var i_sr=0;i_sr<=this.quantity.length-1;i_sr++)
  //   {

 

  //     if(this.quantity[i_sr] == null || this.quantity[i_sr] =="" || this.quantity[i_sr]=="undefined") 
  //     {
       
  //     }
  //     else
  //     {
        
  //       this.totalsum = parseInt(this.totalsum) + parseInt(this.quantity[i_sr]);       
  //     }
  //   }

      // this.invoice_products=[{
      //   unit: [],
      //   selectedfromage: [],
      //   selectedtoage: [],
      //   quantity: [],
      //   factorysize: [],
      // }
      //   ];
        this.invoice_products=[{
        unit: [],
        selectedfromage: [],
        selectedtoage: [],
        quantity: [],
        factorysize: [],
      }];
      // this.temp_sizeset
      // var unit=[];
      // console.log("data[j].sizeset_caption",data[0].sizeset_caption)
      // for(var j=0;j<this.selected_size_id.length;j++){
      //   alert("In")
      //   unit.push(data[j].sizeset_caption)
      // }
      // console.log("SachinSAchin",unit)
      // alert(data[0].sizeset_caption)
       for(var i=0;i< this.selected_size_id.length; i++){
        if(this.invoice_products[0]){

          this.invoice_products[0].unit.push(data[i].unit);
          this.invoice_products[0].selectedfromage.push(data[i].selectedfromage);
          this.invoice_products[0].selectedtoage.push(data[i].selectedtoage);
          this.invoice_products[0].quantity.push(qty);
          this.invoice_products[0].factorysize.push(factorysize);
        }
        

      }
      console.log("new data",this.invoice_products)
      console.log("old data", this.selected_sizedata)

    var newData = [];
    newData.push(this.selected_sizedata[0]);

        var oldUnitArray = this.selected_sizedata[0].unit;
        console.log("oldUnitArray", oldUnitArray);

        var newUnitArray = this.invoice_products[0].unit;
        console.log("newUnitArray", newUnitArray);

        for (var i = 0; i < newUnitArray.length; i++) {
        var updateAtIndex = oldUnitArray.indexOf(newUnitArray[i]);
        console.log("updateAtIndex", updateAtIndex);

        if (updateAtIndex === -1) {
            // If unit doesn't exist in old data, add it
            this.selected_sizedata[0].unit.push(newUnitArray[i]);
            this.selected_sizedata[0].selectedfromage.push(this.invoice_products[0].selectedfromage[i]);
            this.selected_sizedata[0].selectedtoage.push(this.invoice_products[0].selectedtoage[i]);
            this.selected_sizedata[0].quantity.push('');
            this.selected_sizedata[0].factorysize.push(this.invoice_products[0].factorysize[i]);
            this.selected_sizedata[0].mrp.push(this.invoice_products[0].mrp[i]);
        } else {
            // If unit exists in old data, update values
            this.selected_sizedata[0].selectedfromage[updateAtIndex] = this.invoice_products[0].selectedfromage[i];
            this.selected_sizedata[0].selectedtoage[updateAtIndex] = this.invoice_products[0].selectedtoage[i];
            this.selected_sizedata[0].quantity[updateAtIndex] = this.invoice_products[0].quantity[i];
            this.selected_sizedata[0].factorysize[updateAtIndex] = this.invoice_products[0].factorysize[i];
            this.selected_sizedata[0].mrp[updateAtIndex] = this.invoice_products[0].mrp[i];
        }
        }

        const array = this.selected_sizedata[0].quantity[0];
            const lengthToSum = this.selected_sizedata[0].unit.length; // Change this to the desired length

            let sum = 0;

            // Iterate over the first 'lengthToSum' elements and accumulate the sum
            for (let i = 0; i < lengthToSum && i < array.length; i++) {
                sum += parseInt(array[i]);
            }

            this.totalsum = sum      
      const Obj={
        style_id: this.$route.params.id,
        size_details: JSON.stringify(this.selected_sizedata)
      }
      //console.log(Obj)
      //return
      axios.post(`${CONSTANTS.API_URL}/updateSizeSetData`,Obj)
      .then(response => {

        document.getElementById("overlay").style.display = "none";
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          this.selected_arr  = this.result.returnvalue;
         this.getdesigndetail();
         this.size_flag=1;
          
        }else {
         this.selected_arr =[];
         // this.totalRows=0;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
      
  
},

        // Change Drop Down Value for Month & Year By Prasad
changeMonthYearVal: function(value_for,index)
{
  
 
 // this.selectedfromage[index]=null;

 

  if(value_for==0) //month
  {
  //this.age_from[index] ="";
  this.age_from[index] = this.year_arr;
    this.selectedfromage[index]= this.year_arr;
  }
  else
  {
     this.age_from[index] = this.month_arr;
    this.selectedfromage[index]= this.year_arr;
  }
  
},

        myFunction: function() {
        var input, filter, table, tr, td, i, txtValue;
        input = document.getElementById("myInput");
        filter = input.value.toUpperCase();
        table = document.getElementById("myTable");
        tr = table.getElementsByTagName("tr");
        for (i = 0; i < tr.length; i++) {
          td = tr[i].getElementsByTagName("td")[0];
          if (td) {
            txtValue = td.textContent || td.innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
              tr[i].style.display = "";
            } else {
              tr[i].style.display = "none";
            }
          }       
        }
      },



        addVendor: function(){
         
          this.showvendordetails = false;
      
        },
        cancelVendor: function(){
          this.isCheckAll = !this.isCheckAll;
          this.selectedvendors = [];
          this.selectedvendors_length = 0;
          this.showvendordetails = false;
        },

        //function for venodr list

            checkAll: function(){
                
                this.isCheckAll = !this.isCheckAll;
                this.selectedvendors = [];
                if(this.isCheckAll){ // Check all
                  for (var key in this.vendor_options) {
                    this.selectedvendors.push(this.vendor_options[key]);
                    this.selectedvendors_length = this.selectedvendors.length
                  }
                }
              
          },
          updateCheckall: function(){
            if(this.selectedvendors.length == this.vendor_options.length){
               this.isCheckAll = true;
               this.selectedvendors_length = this.selectedvendors.length;
                    
            }else{
               this.isCheckAll = false;
               this.selectedvendors_length = this.selectedvendors.length;
                    
            }
          },
          printValues: function(){
            this.selectedvendors = "";
            for (var key in this.selectedvendors) {
               this.selectedvendors += this.selectedvendors[key]+", "; 
            }
          },
        //function for vendor list
        openvendorModal(value) {
        this.showvendordetails =true;
 },
      

              //Function for chnage age type
      changeagetype: function(value1,index){

        if(value1[index]===0)
        {
          this.age_from[index]= [
          { value: '1', text: '1' },
          { value: '2', text: '2' },
          { value: '3', text: '3' },
          { value: '4', text: '4' },
          { value: '5', text: '5' },
          { value: '6', text: '6' },
          { value: '7', text: '7' },
          { value: '8', text: '8' },
          { value: '9', text: '9' },
          { value: '10', text: '10' },
          { value: '11', text: '11' },
          { value: '12', text: '12' },
          { value: '13', text: '13' },
          { value: '14', text: '14' },
          { value: '15', text: '15' },
          { value: '16', text: '16' },
          { value: '17', text: '17' },
          { value: '18', text: '18' },
          { value: '19', text: '19' },
          { value: '20', text: '20' },
          { value: '21', text: '21' },
          { value: '22', text: '22' },
          { value: '23', text: '23' },
          { value: '24', text: '24' }
          ];
        this.age_to[index]= [
          { value: '1', text: '1' },
          { value: '2', text: '2' },
          { value: '3', text: '3' },
          { value: '4', text: '4' },
          { value: '5', text: '5' },
          { value: '6', text: '6' },
          { value: '7', text: '7' },
          { value: '8', text: '8' },
          { value: '9', text: '9' },
          { value: '10', text: '10' },
          { value: '11', text: '11' },
          { value: '12', text: '12' },
          { value: '13', text: '13' },
          { value: '14', text: '14' },
          { value: '15', text: '15' },
          { value: '16', text: '16' },
          { value: '17', text: '17' },
          { value: '18', text: '18' },
          { value: '19', text: '19' },
          { value: '20', text: '20' },
          { value: '21', text: '21' },
          { value: '22', text: '22' },
          { value: '23', text: '23' },
          { value: '24', text: '24' }
          ]
        }
        else if(value1[index]===1){
          this.age_from[index]= [
          { value: '1', text: '1' },
          { value: '2', text: '2' },
          { value: '3', text: '3' },
          { value: '4', text: '4' },
          { value: '5', text: '5' },
          { value: '6', text: '6' },
          { value: '7', text: '7' },
          { value: '8', text: '8' },
          { value: '9', text: '9' },
          { value: '10', text: '10' },
          { value: '11', text: '11' },
          { value: '12', text: '12' }          
          ];
        this.age_to[index]= [
          { value: '1', text: '1' },
          { value: '2', text: '2' },
          { value: '3', text: '3' },
          { value: '4', text: '4' },
          { value: '5', text: '5' },
          { value: '6', text: '6' },
          { value: '7', text: '7' },
          { value: '8', text: '8' },
          { value: '9', text: '9' },
          { value: '10', text: '10' },
          { value: '11', text: '11' },
          { value: '12', text: '12' }          
          ]
        }
       // alert(value2);
      },
        
        // Function For agegroup
       //  changeagetovalue: function (value,index) {
       //     var j=parseInt(value[index]);
       //     j= j;
       //     if(this.selected_month[index] =='0')
       //     {
       //       for(var i=j; i<=24;i++){
       //        this.age_torange.push(i);
       //        this.to_month_arr = this.age_torange;
       //       }
       //      }
       //      else if(this.selected_month[index] =='1')
       //      {
       //        for(var i=j; i<=12;i++){
       //        this.age_torange.push(i);
       //        this.to_year_arr = this.age_torange;
       //       }
       //      }
       //     this.age_torange= [];
       // },
        // Function For agegroup ends
       
               /****** Function to design details ********/
       getdesigndetail: function(){
   
           this.isBusy = true;
       
           const Obj = {
                style_id: this.$route.params.id,  
                // style_id:65            
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
            this.style_details  = this.result.returnvalue[0];
            // this.selected_sub_catid= this.style_details.sub_catid;
            // this.selected_sizedata=this.style_details.size_details;
            this.sizeset = this.style_details.no_of_sizeset;
            this.selected_brandid = this.style_details.brand_id;
            this.selected_sub_catid = this.style_details.sub_catid;
            this.getsizecaption(this.selected_brandid,this.selected_sub_catid)
            this.material = this.style_details.material
            this.final_grade = this.style_details.final_grade;
            this.getMinMaxRangeFromFinalGrade(this.final_grade)
            // for(var i=1;i<=this.style_details.no_of_sizeset;i++){
            //   this.sizeset.push(i);
            // }
          
            this.totalRows = this.result.returnvalue.length;
            this.temp_sizeset=this.style_details.no_of_sizeset;
             if(this.style_details.size_details[0].unit && this.style_details.size_details[0].unit.length!=0){
                  for(let i=0;i<this.style_details.size_details[0].unit.length;i++){
                  var temp_selected_unit= this.style_details.size_details[0].unit;
              }
                }
              if(this.style_details.size_details[0].selectedfromage && this.style_details.size_details[0].selectedfromage.length!=0){
                for(let i=0;i<this.style_details.size_details[0].selectedfromage.length;i++){
                var temp_selected_fromage= this.style_details.size_details[0].selectedfromage;
              }
              }
              if(this.style_details.size_details[0].selectedtoage && this.style_details.size_details[0].selectedtoage.length!=0){
                for(let i=0;i<this.style_details.size_details[0].selectedtoage.length;i++){
                var temp_selected_toage=this.style_details.size_details[0].selectedtoage;
              }
              }
              var temp_qty = []
              if(this.style_details.size_details[0].quantity && this.style_details.size_details[0].quantity.length!=0){
                for(let i=0;i<this.style_details.size_details[0].unit.length;i++){
                  if(this.style_details.size_details[0].quantity[0][i]!=undefined){
                    temp_qty.push(this.style_details.size_details[0].quantity[0][i]);
                    
                  }
                }
              }
              var temp_factorysize = []
              if(this.style_details.size_details[0].factorysize && this.style_details.size_details[0].factorysize.length!=0){
                for(let i=0;i<this.style_details.size_details[0].unit.length;i++){
                  if(this.style_details.size_details[0].factorysize[0][i]!=undefined){
                    // var temp_factorysize= this.style_details.size_details[0].factorysize[0];
                    temp_factorysize.push(this.style_details.size_details[0].factorysize[0][i])
                    
                  }
                }
              }

               var temp_mrp = []
                if(this.style_details.size_details[0].mrp && this.style_details.size_details[0].mrp.length!=0){
                    for(let i=0;i<this.style_details.size_details[0].unit.length;i++){

                    if(this.style_details.size_details[0].mrp[0][i]!=undefined){
                    temp_mrp.push(this.style_details.size_details[0].mrp[0][i])
                    }
                }
                }  
                if(this.style_details.size_details[0].uk && this.style_details.size_details[0].uk.length!=0){
                    for(let i=0;i<this.style_details.size_details[0].uk.length;i++){
                      var temp_uk = this.style_details.size_details[0].uk
                  }
                }
                if(this.style_details.size_details[0].us && this.style_details.size_details[0].us.length!=0){
                    for(let i=0;i<this.style_details.size_details[0].us.length;i++){
                      var temp_us  = this.style_details.size_details[0].us;
                  }
                }
                if(this.style_details.size_details[0]['brand_size_euro'] && this.style_details.size_details[0]['brand_size_euro'].length!=0){
                    for(let i=0;i<this.style_details.size_details[0]['brand_size_euro'].length;i++){
                    var temp_brand_size_euro =  this.style_details.size_details[0].brand_size_euro;
                  }
                }
                if(this.style_details.size_details[0]['foot_length_cm'] && this.style_details.size_details[0]['foot_length_cm'].length!=0){
                    for(let i=0;i<this.style_details.size_details[0]['foot_length_cm'].length;i++){
                    var temp_foot_length_cm = this.style_details.size_details[0].foot_length_cm
                  }
                }


                  this.unit=temp_selected_unit;
                  this.selectedfromage= temp_selected_fromage;
                  this.selectedtoage= temp_selected_toage;
                  this.quantity= temp_qty;
                  this.factorysize= temp_factorysize;   
                  this.mrp = temp_mrp;
                  this.uk = temp_uk;
                  this.us = temp_us;
                  this.brand_size_euro = temp_brand_size_euro;
                  this.foot_length_cm = temp_foot_length_cm;


                  let tempObj = {}
                  tempObj.unit = temp_selected_unit
                  tempObj.selectedfromage = temp_selected_fromage;
                  tempObj.selectedtoage = temp_selected_toage;
                  tempObj.quantity = [temp_qty]
                  tempObj.factorysize = [temp_factorysize]
                  tempObj.uk = temp_uk
                  tempObj.us = temp_us
                  tempObj.brand_size_euro = temp_brand_size_euro;
                  tempObj.foot_length_cm = temp_foot_length_cm;


                  tempObj.mrp = [temp_mrp]
                  let tempArr = []
                  tempArr.push(tempObj)


            this.selected_sizedata = tempArr       
                  for(var i=0;i<=this.totalRows;i++){
                    if(this.style_details.status_code_number>=8){
                      this.file_tab_status =true;
                      
                    }
            }

            this.displayvendorlist(this.selected_brandid,this.selected_sub_catid);
            // this.poformdata(this.selected_sub_catid);

            this.totalRows = this.result.returnvalue.length;

             }else {
              this.style_details =[];
              this.totalRows=0;
                this.isBusy = !this.isBusy;
             }
   
   
           })
           // .catch(e => {
           //   this.errors.push(e)
           // })
   
   
       },

       poformdata: function(){
        const Obj={
          subcat_id: this.selected_sub_catid,
          brand_id: this.selected_brand_id,
          style_id: this.$route.params.id
        }
        axios.post(`${CONSTANTS.API_URL}/getFabricTypeList`,Obj)
           .then(response => {

            document.getElementById("overlay").style.display = "none";
             this.result = response.data;
             if (this.result.returnmsg === 'Successful') {
               this.fabric_arr=this.result.returnvalue[0].Fabric;
               this.fabrictype_arr = this.result.returnvalue[0].FabricType;
            //    console.log("EEEEEEEEEEEEEEEEEEE",this.fabrictype_arr);
               this.solematerial_Sole_Material_arr = this.result.returnvalue[0].Bottom_Fabric_Sole_Material;
               this.materialinfoupperfabric_Upper_Fabric_arr = this.result.returnvalue[0].Top_Fabric_Upper_Fabric;
               this.sleeveLength_arr = this.result.returnvalue[0].SleeveLength;
              
             }else {
              this.items =[];
              this.totalRows=0;
              this.isBusy = !this.isBusy;
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })      

      
       },


       getfabrictype: function(){
        const Obj={
          subcat_id: this.selected_sub_catid,
          brand_id: this.selected_brand_id,
          style_id: this.$route.params.id
        }
        axios.post(`${CONSTANTS.API_URL}/getfabrictype`,Obj)
           .then(response => {

            document.getElementById("overlay").style.display = "none";
             this.result = response.data;
             if (this.result.returnmsg === 'Successful') {
      
               this.sleeveLength_arr = this.result.returnvalue[0].SleeveLength;
              
             }else {
              this.sleeveLength_arr=[]
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })      

      
       },

       validateForm4(scope,quantity){        
        this.temp_count=0;
        for(var i=0;i<=quantity.length;i++){
          if(quantity[i]!=undefined){
            this.temp_count=this.temp_count+1;
          }
        }
        this.qtycount=0;
          const regex = /^[1-9]\d*(\.\d+)?$/;
          for(var i=0;i<=this.temp_count;i++){
        
          const str = regex.test( quantity[i] ) ? 'Match!' : 'No Match';
          if(str=='No Match'){
          
            this.counter=this.counter+1;
            
          }
          else
          {
            
              this.qtycount=this.qtycount+1;
            
            // document.getElementById('upload_btn').style.display="block";
          }
      }
       // if(this.qtycount==this.temp_count){
      //   if(this.selectedvendors.length==0){
      //     // alert("Please Select Vendor");
      //     this.$fire({
      //            text:"Please Select Vendor.",
      //            type: "warning",
      //            timer: 30000
      //                   })
      // }

      if(this.requestedDate<this.submissionDate){
            // alert("Expected Delivery Date must be greater than Quote Submission Date");
             this.$fire({
                 text:"Expected Delivery Date must be greater than Quote Submission Date.",
                 type: "warning",
                 timer: 30000
                        })
          }
      else if(this.requestedDate!='' && this.submissionDate!=''){

        this.$validator.validateAll(scope).then(result => {
        if (result) {

           this.requestedquotesForm();
         //}
        
        }
      });
      }
      else{
        this.$fire({
                 text:"Please Select Date",
                 type: "warning",
                 timer: 30000
                        })
      }
     // }
     //  else
     //     {
     //       this.$fire({
     //            text:"Please Enter Positive Numbers Only",
     //            type: "warning",
     //            timer: 300000
     //                  })
     //     } 
    },
        /******Function For Requested Quotes*******/
        requestedquotesForm(){
          // alert(this.quantity.length)
          // alert(this.selected_sizedata[0].unit.length)
          // if(this.quantity.length != this.selected_sizedata[0].unit.length)
          // {

          //    this.$fire({
          //     text:"Please enter Factory size and quantity for size",
          //     type: "error",
          //     timer: 30000
          //   })
            
          // }
          // else{
          document.getElementById("overlay").style.display = "block";
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
          this.id = this.$route.params.id;  
          // var vendorarr=[];
          // vendorarr=this.selectedvendors;
          var delivery_date = (this.requestedDate!=null)?this.formatDate(this.requestedDate):"";
          var submission_date = (this.submissionDate != null) ? this.formatDate(this.submissionDate) : "";
          var fabrictype = (this.fabrictype != null) ? this.formatDate(this.fabrictype) : "";
          var materialinfoupperfabric = (this.materialinfoupperfabric != null) ? this.formatDate(this.materialinfoupperfabric) : "";
          var solematerial = (this.solematerial != null) ? this.formatDate(this.solematerial) : "";
          var fabriccomposition = (this.fabriccomposition != null) ? this.formatDate(this.fabriccomposition) : "";
          var sleevelength = (this.sleevelength != null) ? this.formatDate(this.sleevelength) : "";
          var selectedagegroup=(this.selectedage!=null)? this.selectedage:"";
          var size_details = this.selected_sizedata[0];
         var check_val=0;
         if( this.size_details && this.size_details.selectedfromage[0]){
          var temp_from_age=this.size_details.selectedfromage[0];
         }
         if(this.size_details && this.size_details.selectedtoage[0]){
          var temp_to_age=this.size_details.selectedtoage[0];
         }
        // console.log("temp_from_agetemp_from_age",temp_from_age);
        // console.log("temp_to_agetemp_to_age",temp_to_age);
        var main_arr=[];
        // main_arr.push(this.invoice_products[0])
    

        // for(var i=0; i<temp_from_age.length;i++)
        // {
         
        //   if(parseInt(temp_from_age[i]) > parseInt(temp_to_age[i]))
        //   {

        //     // alert("Size "+ parseInt(i+ 1) +" Position 'Age To' Value Should Be Greater Than Or Equal To 'Age From' Value");
        //      this.$fire({
        //          text:"Size "+ parseInt(i+ 1) +" Position 'Age To' Value Should Be Greater Than Or Equal To 'Age From' Value",
        //          type: "warning",
        //          timer: 30000
        //                 })
        //     check_val=0;
            
        //     document.getElementById("overlay").style.display = "none";
        //     // return false;

        //   }
        //   else
        //   {
           
        //     check_val=check_val+1;
            
        //   }
        // }

       
        // if(check_val==temp_from_age.length){
          const fileObj = {
                
                style_id: this.id,
                size_details: JSON.stringify(this.selected_sizedata),
                // vendor_id: vendorarr,
                delivery_date: `${delivery_date}`,
                submission_date: `${submission_date}`,
                total_quantity : this.totalsum,
                target_price: this.target_price,
                quote_remarks: this.quote_remarks,
                fabrictype: this.fabrictype,
                material: this.material,
                materialinfoupperfabric: this.materialinfoupperfabric,
                solematerial: this.solematerial,
                fabriccomposition: this.fabriccomposition,
                sleevelength: this.sleevelength,
                created_by:userInfo[0].email_id,
                total_mrp : this.total_mrp,
                upper_material: this.upper_material,
                inner_lining: this.inner_lining,
                sole:this.sole,
                surface_ornamentation: this.surface_ornamentation,
                highlight: this.highlight,
                Fastening_type: this.Fastening_type
          }
              axios.post(`${CONSTANTS.API_URL}/editquotetovendors`,fileObj)
              .then(response => {
                document.getElementById("overlay").style.display = "none";
                  if(response.data.returnmsg == 'Successful') {
                  
                      // alert("Quote Submitted Successfully.");
                    this.$fire({
                      text:"Quote Submitted Successfully.",
                      type: "success",
                      timer: 30000
                    })
                    this.isHidden= true;
                    this.getqutationdetails();
                    this.selectedvendors = []
                    var id=parseInt(this.route_id);
                    this.getdesigndetail();
                    // this.$router.go(-1)

                  } else {
                    if (result.body.returnmsg === 'NoUserExists') {

                      this.showAlert=true
                      
                    }
                  }
              })
       // }

      //  }

      
    },
        /******Function For Requested Quotes Ends*******/

           /*******Function for Get Selected Vendors quote List********/
      getselectedvendorsquote: function() {
        document.getElementById("overlay").style.display = "block";
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)

          const Obj={
              style_id: this.$route.params.id
          }
        axios.post(`${CONSTANTS.API_URL}/getselectedvendorsquote`,Obj)
          .then((result) => {
            document.getElementById("overlay").style.display = "none";
            if (result.data.returnmsg === 'Successful') {
               this.quotationlist = result.data.returnvalue;
               this.requestedDate = result.data.returnvalue.created_date;
               this.submissionDate = result.data.returnvalue.effective_date;
               this.target_price = result.data.returnvalue.target_price;
               this.totalsum = result.data.returnvalue.total_quantity;
               // var temp_selected_unit= this.quotationlist.size_details[0].unit[0];
               // var temp_selected_fromage= this.quotationlist.size_details[0].selectedfromage[0];
               // var temp_selected_toage=this.quotationlist.size_details[0].selectedtoage[0];
               // var temp_qty=this.quotationlist.size_details[0].quantity[0];
               // console.log("))))))))))))))))))))",this.quotationlist.size_details[0].quantity[0].length);
               // for( var i =0 ; i<this.quotationlist.size_details[0].quantity[0].length;i++){
               //  this.selected_month[i]=temp_selected_unit[i];
               //  this.selectedfromage[i]=temp_selected_fromage[i];
               //  this.selectedtoage[i]= temp_selected_toage[i];
               //  this.quantity[i]= temp_qty[i];
               // }

               
             }else {
              this.quotationlist =[];
              this.totalRows=0;
              // this.isBusy = !this.isBusy;
             }
          })
          .catch((ex) => {
            console.log('error', ex)
          })
    },
    /*******Function for Get Selected Vendors quote List Ends********/


       /*******Function for Vendor List********/
      displayvendorlist: function(brand_id,subcat_id) {
        this.vendor_options=[]
        document.getElementById("overlay").style.display = "block";
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var recarr=[];

          recarr=this.selectedVendor;
          const Obj={
               //brand_id: 621,
               subcat_id: this.selected_sub_catid,
               brand_id:brand_id,
               
              style_id: this.$route.params.id
          }
          // style_id->143
        //agentmaster

        axios.post(`${CONSTANTS.API_URL}/getvendorlist`,Obj)
          .then((result) => {
            document.getElementById("overlay").style.display = "none";
            this.vendor_msg = result.data.returnmsg;
            this.agentmaster = result.data.returnvalue;
             for(var i = 0; i < this.agentmaster.length; i++) {
              var vendoryagent2 = {
                id: this.agentmaster[i].vendor_id
              }
              this.vendor_options.push(this.agentmaster[i].vendor_id);
                  
              }
              

          }) 
          .catch((ex) => {
            document.getElementById("overlay").style.display = "none";
            console.log('error', ex)
          })
    },


    // Function For Quotation listing
  getqutationdetails: function () {


       var userData = localStorage.getItem('userData');
      // if (userData) 
      // {
           var userInfo = JSON.parse(userData)
           this.vendor_id = userInfo[0].vendor_id; 

        
           const Obj = {
                style_id:this.$route.params.id
              }
           //this.isBusy = true;
           //var userdata = localStorage.getItem('userData')
          // var userInfo = JSON.parse(userdata);
           axios.post(`${CONSTANTS.API_URL}/getqutationdetails`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             // JSON responses are automatically parsed.
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
               this.quateitemlist = this.result.returnvalue;

               this.totalRows = this.result.returnvalue.length;
               this.quote_remarks = this.result.returnvalue[0].remark
      
               //this.isBusy = !this.isBusy;

               
             }else {
              this.quateitemlist =[];
              this.totalRows=0;
              this.isBusy = !this.isBusy;
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })
   
         //}       

       },

    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },

    savechartfunc(){
      this.getfabrictype();
    },

    removeSize(index){
      console.log('removeSize index----->',index)
      console.log('before removeSize----->',this.selected_sizedata)
      try{
      if(this.selected_sizedata[0].unit.length > 1){
        // let newSizeDataObj = {
        //   unit:this.unit,
        //   selectedfromage:this.selectedfromage,
        //   selectedtoage: this.selectedtoage,
        //   quantity: [this.quantity,0,0],
        //   factorysize: [this.factorysize,0,0]
        // }
        // if(newSizeDataObj.unit[index]) newSizeDataObj.unit.splice(index,1) 
        // if(newSizeDataObj.selectedfromage[index]) newSizeDataObj.selectedfromage.splice(index,1)
        // if(newSizeDataObj.selectedtoage[index]) newSizeDataObj.selectedtoage.splice(index,1)
        // if(newSizeDataObj.quantity[0][index]) newSizeDataObj.quantity[0].splice(index,1)
        // if(newSizeDataObj.factorysize[0][index]) newSizeDataObj.factorysize[0].splice(index,1)
       


        let newSizeDataObj = {
         ...this.selected_sizedata[0]
        }

        

        if(newSizeDataObj.unit && newSizeDataObj.unit[index]) newSizeDataObj.unit.splice(index,1) 
        if(newSizeDataObj.selectedfromage && newSizeDataObj.selectedfromage[index]) newSizeDataObj.selectedfromage.splice(index,1)
        if(newSizeDataObj.selectedtoage && newSizeDataObj.selectedtoage[index]) newSizeDataObj.selectedtoage.splice(index,1)
        if(newSizeDataObj.uk && newSizeDataObj.uk[index]) newSizeDataObj.uk.splice(index,1)
        if(newSizeDataObj.us && newSizeDataObj.us[index]) newSizeDataObj.us.splice(index,1)
        if(newSizeDataObj.foot_length_cm && newSizeDataObj.foot_length_cm[index]) newSizeDataObj.foot_length_cm.splice(index,1)
        if(newSizeDataObj.brand_size_euro && newSizeDataObj.brand_size_euro[index]) newSizeDataObj.brand_size_euro.splice(index,1)


        if(newSizeDataObj.quantity && newSizeDataObj.quantity[0]) {
        newSizeDataObj.quantity[0].splice(index,1)

        }
        if(newSizeDataObj.factorysize && newSizeDataObj.factorysize[0]){
          newSizeDataObj.factorysize[0].splice(index,1)
        }

         if(newSizeDataObj.mrp && newSizeDataObj.mrp[0]){

          newSizeDataObj.mrp[0].splice(index,1)
        }

        let tempArr = []
        tempArr.push(newSizeDataObj)
        this.selected_sizedata = tempArr

        let sum = 0
        for(let i=0;i<=newSizeDataObj.unit.length;i++){
          if(newSizeDataObj.quantity[0][i]){
            sum += parseInt(newSizeDataObj.quantity[0][i])
          }
        }
        this.totalsum = sum

        const Obj={
          style_id: this.$route.params.id,
          size_details: JSON.stringify(this.selected_sizedata)
        }
        axios.post(`${CONSTANTS.API_URL}/updateSizeSetData`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data
          if (this.result.returnmsg === 'Successful') {
            this.selected_arr  = this.result.returnvalue;
            this.getdesigndetail();
            this.size_flag=1;
          }else {
            this.selected_arr =[];
          }
        })
        .catch(e => {
          document.getElementById("overlay").style.display = "none";
          this.fire({text:"Error in Updating Size Details!",type:'error'})
        })
        
      }else{
        this.$fire({
          text:"Atlest one size is required",
          type: "warning",
          timer: 30000
        })
      }
      }catch(err){
        console.log(err)
        this.$fire({
          text:"Error in removing sizeset!",
          type: "error",
          timer: 30000
        })
      }
    },

    removeSizeWrong(index)
    {
      // alert(index);
      // console.log(this.quantity,"this.quantity")
      // console.log(this.quantity.splice(-1))
      // die();
        // alert(this.selected_sizedata[0].unit.length)
        console.log("existing this.selected_sizedata before removeSize",this.selected_sizedata)

        let dynamicIndex = index /* your dynamically obtained index */;
        if(this.selected_sizedata[0].unit.length > 1){

           if (dynamicIndex > 0 && dynamicIndex < this.selected_sizedata[0].unit.length) {
            // Use splice to remove the element at the dynamicIndex from the 'unit' array
            this.selected_sizedata[0].unit.splice(dynamicIndex, 1);

              // Also, remove corresponding elements from other arrays
              // console.log('this.selected_sizedata[0].selectedfromage---->',this.selected_sizedata[0].selectedfromage)
              this.selected_sizedata[0].selectedfromage.splice(dynamicIndex, 1);
              // console.log('this.selected_sizedata[0].selectedtoage.splice(dynamicIndex, 1)---->',this.selected_sizedata[0].selectedtoage.splice(dynamicIndex, 1))
              this.selected_sizedata[0].selectedtoage.splice(dynamicIndex, 1);
              // console.log('this.selected_sizedata[0].quantity.splice(dynamicIndex, 1)--------->',this.selected_sizedata[0].quantity.splice(dynamicIndex, 1))
              this.selected_sizedata[0].quantity.splice(dynamicIndex, 1);
              // console.log('this.selected_sizedata[0].factorysize.splice(dynamicIndex, 1)------>',this.selected_sizedata[0].factorysize.splice(dynamicIndex, 1))
              this.selected_sizedata[0].factorysize.splice(dynamicIndex, 1);
              this.selected_sizedata[0].mrp.splice(dynamicIndex, 1);

              // Log the updated array (optional)
              console.log("Updated selected_sizedata after removeSize", this.selected_sizedata);
              this.calculateTotalQuantity(); 
              var tempqtydata = this.quantity.splice(-1)
             this.quantity.push(tempqtydata)
             var temfactorydata = this.factorysize.splice(-2)
             this.factorysize.push(temfactorydata) 
             var temmrpData = this.factorysize.splice(-2)
             this.mrp.push(temmrpData) 
              
          } else {
              console.error("Invalid index:", dynamicIndex);
          }

        }
        else{

          this.$fire({
                      text:"Atlest one size is required",
                      type: "warning",
                      timer: 30000
                    })

        }
        
        
    },

    sendDataToParent(){
      // alert();
      console.log('this.showEditSizedetailsModal#################',this.showEditSizedetailsModal);
      this.showEditSizedetailsModal = false;
      const data = this.showcomponetModel

      this.$emit('closeeditsizemodal', data);

    },

    getMinMaxRangeFromFinalGrade: function (final_grade){
      // alert(final_grade)
         const Obj = {
          final_grade : final_grade
        }

        axios.post(`${CONSTANTS.API_URL}/getMinMaxRangeFromFinalGrade`,Obj)
       .then(response => {
        if(response.data.returnmsg=='Successful')
        {
          this.minRange = response.data.returnvalue[0].min;
          this.maxRange = response.data.returnvalue[0].max;
        }
        else{
          this.caption_data =[];
        }
        
        
      }).catch((err) =>{
          return new Error(err.message);
        })
         },
   
   
     }
   };
</script>
<style>
   .short-div {
   height:55px;
   }


.quote-dropdowns .dropdown--accepted {
    border-top: 1px solid var(--fill-green-dark);
}

.quote-dropdowns>.card {
    background-color: var(--fill-white);
}
.quote-dropdowns .dropdown__header.dropdown__header--accepted {
    border: 1px solid var(--fill-green-dark);
    border-top: none;
    background-color: #e8fff5;
}
.card .card__section {
    flex-grow: 1;
    box-shadow: inset 0 -1px 0 0 #e5e5e5;
    box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .dropdown__header {
    align-items: center;
    justify-items: center;
    justify-content: center;
    cursor: pointer;
}
.quote-dropdowns .card__section {
    padding: 16px 32px;
}
.f-sz-l {
    font-size: 15px;
}
.flex-col {
    flex-direction: column;
}
.flex, .flex-col {
    display: flex;
}
.f-w-semi-bold {
    font-weight: 600;
}
.f-sz-sm {
    font-size: 12px;
}
.f-w-semi-bold {
    font-weight: 600;
}   

.card .card__section {
    flex-grow: 1;
    box-shadow: inset 0 -1px 0 0 #e5e5e5;
    box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .card__section {
    padding: 16px 32px;
}

.input-grp {
    width: 100%;
    margin-bottom: 16px;
}
.input-grp {
    margin-bottom: 10px!important;
}

.input-grp label {
    margin-bottom: 6px;
    color: #333340;
}

input[type=number], input[type=password], input[type=tel], input[type=text] {
    padding: 13px 12px;
    border-radius: 2px;
    border: 1px solid #bfbfbf;
}
.input-grp input, .input-grp label, .input-grp select {
    display: block;
    width: 100%;
}

.input-grp select:disabled {
    background-color: #ebebe4;
}
.input-grp select {
    background: url(/static/media/ic-arrow-drop-down.1f6abe65.svg) no-repeat;
    background-position: right 8px top 6px;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
}

.quote-dropdowns .dropdown__header.dropdown__header--accepted {
    border: 1px solid var(--fill-green-dark);
    border-top: none;
    background-color: #e8fff5;
}
  
    .main_body1{
      width: 970px;
    }
   
    .container{
      align-content: center;
    }
    .search{
      border-radius: 15px 0 0 15px !important;
      background-color: white !important;
      border:0 !important;
      color:white !important;
    }
    .search:focus{
         box-shadow:none !important;
          outline:0px !important;
    }
    /*.type_msg{
      background-color: white !important;
      border:0 !important;
      color:white !important;
      height: 60px !important;
      overflow-y: auto;
    }*/
      #type_msg:focus{
         box-shadow:none !important;
           outline:0px !important;
    }
    .send_btn{
      border:1 !important;
      border-color: #20a8d8;
      background-color: #4d94ff;
      cursor: pointer;
    }
    .search_btn{
      border-radius: #20a8d8 !important;
      border:0 !important;
      background-color: #20a8d8;
      cursor: pointer;
    }
    .contacts{
      list-style: none;
      padding: 0;
    }
    .contacts li{
      width: 100% !important;
      padding: 5px 10px;
      margin-bottom: 15px !important;
    }
    .user_img{
      height: 40px;
      width: 30px;
      border:1.5px solid #f5f6fa;
      margin-left: 10px;

    }
    .user_img_msg{
      height: 30px;
      width: 30px;
      border:1.5px solid #f5f6fa;
    
    }
/*  .img_cont{
      position: relative;
      height: 70px;
      width: 70px;

  }
  .img_cont_msg{
      height: 40px;
      width: 40px;
  }*/
  .text-span{
    background:blue;
    border-radius:50%;
    height: 26px;
    width: 26px;
    line-height: 26px;
    display: inline-block;
    text-align: center;
    margin-right: 6px;
}
.text-span2{
    background:gray;
    border-radius:50%;
    height: 26px;
    width: 26px;
    line-height: 26px;
    display: inline-block;
    text-align: center;
    margin-right: 6px;
}
  .brand-card{
   border-radius:0px !important;
  }

     .sidebar{
   background: #17a2b8!important;
   width:50px !important;
   }

   .sidebar .sidebar-nav{
    width:50px !important;
   }
   .sidebar .nav{
    width:50px !important;
   }

   .main{
    margin-left:50px !important;
   }
   #rec_msg{    
    margin-left: 40%;
    position: absolute;
   }


/*** Tabb ***/
.header-tabs__navbar {
    margin-top: auto;
    align-items: center;
    border-top: 1px solid var(--fill-grey-light2);
}
.flex {
    display: flex;
}

.header-tabs__tab {
    position: relative;
    flex: 1 1;
    height: 43px !important;
    padding: 12px 22px;
    border-bottom: 3px solid var(--fill-grey-light3);
    display: flex;
    flex-direction: row;
    cursor: pointer;
    border: 1px solid #63c2de;
    border-radius: 12px;
}

.header-tabs__tab-image {
    padding-right: 8px;
}

.header-tabs__tab-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
 
.header-tabs__tab .sub_title {
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    font-weight: 400;
    color: var(--fill-grey-medium);
} 



html, body {
  margin: 0
}
.wrapper {
  display: flex;
  flex-direction: column;
  height: 92vh;
  width: 100%;
  background-color:white
}

/*Code For Quotation Details */
  .txt_heading{
    text-align: center;
    font-weight: bold;
  }
  .td2{
    width: 250px;
  }
  #final{
    background: #A9A9A9 !important;
  }
  .inputdata{
    text-align: center;
  }
  #vendor_list_scroll{
    max-height: 500px;
    overflow-y: scroll;
  }
/*Code For Quotation Details Ends*/

/*Todays CSS*/
.nav_row_tabs {
 
  display: flex;
  border-top: 1px solid #D7DBDD;
  border-bottom: 1px solid #D7DBDD;
}

  #activeTitle{
  font-size: 14px;
}
.requesticon{
   padding-top: 8px; 
   color: #24a0ed;
}
.requestvendor{
 width: 500px !important;
 height: 32px;
}
.requestfactory{
  width:  6.25em;
}
.requestquantity{
   width: 9.375em;
}
.requestedcol{
  position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 5px;
}
@media (max-width: 1040px)
{
 .requestedside{
      display: none;
}
.requestvendor{
 /*width: 500px;*/
 height: 32px;
}
}
@media (max-width: 998px)
{
 
.requestvendor{
 width: 120% !important;
 height: 32px;
}
.requestvendorhead{
  font-size:12px;
}
.requestvendorbody{
  font-size:12px;
}
}
@media (max-width: 540px) 
{
  .requestvendor{
 width: 100% !important;
 height: 32px;
}
.requesticon{
  display:none;
}
 .requestedhead{
    font-size: 0.6875em;
}

.requestedbody{
    font-size: 0.6875em;
}
.requestunit{
  width:50px;
  padding:2px;
}
.requestagefrom{
   width:50px;
   padding:2px;
}
.requestageto{
   width:50px;
 padding:2px;
}
.requestfactory{
   /*width:50px;*/
  height: 10px;
}
.requestquantity{
   /*width:50px;*/
  height: 10px;
}
.requestvendorhead{
  font-size:12px;
}
.requestvendorbody{
  font-size:12px;
}
}
@media (max-width: 500px) and (min-width:410px) 
{
 .requestedhead{
    font-size:0.625em;
}
.requestedbody{
    font-size:0.625em;
}
.requestunit{
  width:50px;
  padding:2px;
}
.requestagefrom{
  width:50px;
  padding:2px;
}
.requestageto{
  width:50px;
  padding:2px;
}
.requestfactory{
  width: 60px;
  height: 10px;
}
.requestquantity{
  width: 60px;
   height: 10px;
}
.requestedcol{
  position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 5px;
}
.requestcard{
  padding-left: 10px !important;
}
.requestvendorhead{
  font-size:11px;
}
.requestvendorbody{
  font-size:11px;
}
}
@media (max-width: 400px) and (min-width:350px) 
{
 .requestedhead{
    font-size:0.5625em;
}
.requestedbody{
    font-size:0.5625em;
}
.requestunit{
  width:40px;
   padding:2px;
}
.requestagefrom{
  width:40px;
   padding:1px;
}
.requestageto{
  width:40px;
   padding:2px;
}
.requestfactory{
  width: 50px;
  height: 10px;
  padding:2px;
  
}
.requestquantity{
  width: 50px;
  height: 10px;
   padding:2px;

}
.requestedcol{
  position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 5px;
}
.requestcard{
  padding-left: 0px !important;
}
.requestvendorhead{
  font-size:10px;
}
.requestvendorbody{
  font-size:10px;
}
}
@media (max-width: 340px) and (min-width:280px) 
{
  .requestvendorhead{
  font-size:9px;
}
.requestvendorbody{
  font-size:9px;
}
 .requestedhead{
    font-size:0.5em;
}
.requestedbody{
    font-size:0.5em;
}
.requestunit{
  width:35px;
   padding:0px;
   font-size:11px ;
}
.requestagefrom{
  width:35px;
   padding:0px;
   font-size:11px ;
}
.requestageto{
 width:35px;
   padding:0px;
   font-size:11px ;
}
.requestfactory{
 width:40px;
   padding:0px;
    font-size:11px ;
  /*height: 10px;*/
 
  
}
.requestquantity{
 width:40px;
 padding:0px;
  font-size:11px ;
 /*height: 10px;*/

}
.requestedcol{
  position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 5px;
}
.requestcard{
  padding-left: 0px !important;
}
}


</style>
